export enum TestIds {
  AggregateField = 'aggregateField',
  AggregateFunction = 'aggregateFunction',
  Category = 'category',
  ChartType = 'chartType',
  Datasource = 'dataSource',
  DatePrecision = 'datePrecision',
  Filtering = 'filtering',
  LabelDisplay = 'labelDisplay',
  RelationalClickthroughNotice = 'relationalClickthroughNotice',
  SubCategory = 'subCategory',
}
